import { SnowplowHelper } from "./snowplow_helper";

const snowplowConfigElement = document.getElementById("snowplow-tracking");
const snowplowConfig = JSON.parse(snowplowConfigElement?.textContent || "{}");

const snowplowHelper = snowplowConfigElement
  ? new SnowplowHelper(snowplowConfig)
  : null;

if (snowplowHelper && snowplowConfig.trackPageView) {
  snowplowHelper.trackPageView(
    {
      page_view_context: snowplowConfig.pageViewContext,
      distribution_channel_context: snowplowConfig.distributionChannelContext,
      service_channel_context: snowplowConfig.serviceChannelContext,
    },
    snowplowConfig.trackActivity,
  );
}

// This has to be placed on the window object or the Teaspoon tests can't be mocked correctly
window.snowplowHelper = snowplowHelper;
